export const clientID = "198771232623-gsgru30ms3iuaovvuis36jfqqscmqmou.apps.googleusercontent.com";
export const clientSecret = "PLJudWTCYkb9YHZr9aI4ZbRc";
export const apiKey = "AIzaSyAtWDPR_TUBQUDiMkDDqQGUaOXSIf0trWg";


// WEBPACK FOOTER //
// ./src/config/gapi.js